<ng-container
  *ngIf="catalogService.loadCatalogForSelectedUserSupplierAndOutlet"
>
  <app-header
    (addToCart)="showWidget($event)"
    (addNewCategory)="addNewCategoryClick()"
    (openNotifications)="showUserNotification = true"
  ></app-header>
  <app-cart-widget-preview
    *ngIf="showWidgetCart && !mobile"
    (changed)="closeWidget($event)"
  ></app-cart-widget-preview>
  <ng-container *ngIf="showUserNotification">
    <app-user-notifications (closeNotifications)="showUserNotification = false">
    </app-user-notifications>
  </ng-container>
  <div class="main-core-block"
       #scrollBlock
       id="main-core-scroll"
       (scroll)="hideHeader($event)">
    <router-outlet></router-outlet>
    <ng-container>
      <app-footer [isHideFooter]="isHideFooter"></app-footer>
    </ng-container>
  </div>
  <div
    *ngIf="catalogService.debsModule"
    [loadModule]="catalogService.debsModule"
  ></div>
  <app-general-message
    *ngIf="!!permissionsService.getUserPermissionError()"
    class="general-error"
    [textMessage]="permissionsService.getUserPermissionError() | translate"
    (closeMessage)="permissionsService.setUserPermissionError('')"
    [footerClass]="'permission-error'"
  >
  </app-general-message>
</ng-container>
<app-add-new-category-dialogs
  #addNewCategoryDialogsComponent
>
</app-add-new-category-dialogs>
<app-feedback-panel *ngIf="showFeedbackPanel"
                    [feedbackSteps]="feedbackSteps"
                    [questionnaireId]="questionnaireId">
</app-feedback-panel>
